import { createContext, useContext, useState, useCallback } from 'react'

const NotificationsContext = createContext(null)

export const NotificationsProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([])
    const [lastNotification, setLastNotification] = useState(null)    

    const addNotification = useCallback(({ title, message, ticketId, person }) => {
        const newId = Date.now() + Math.random()
        const newNotification = { id: newId, title, message, ticketId, timestamp: new Date(), person }
        console.log('newNotification', newNotification)
        setNotifications((prev) => [
            newNotification,
            ...prev,
        ])
        setLastNotification(newNotification)
    }, [])


    const removeNotification = useCallback((id) => {
        setNotifications((prev) => prev.filter((n) => n.id !== id))
        if (lastNotification?.id === id) {
            setLastNotification(null)
        }
    }, [lastNotification])

    return (
        <NotificationsContext.Provider value={{ notifications, addNotification, removeNotification, lastNotification }}>
            {children}
        </NotificationsContext.Provider>
    )
}

export const useNotifications = () => useContext(NotificationsContext)
